import script from "./FormGeolocation.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormGeolocation.vue?vue&type=script&setup=true&lang=ts"

import "./FormGeolocation.vue?vue&type=style&index=0&id=6d04ee73&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d04ee73"]])

export default __exports__